module.exports = __webpack_public_path__ + "img/qr_hover.354c7b1e.svg";